export const RECOMMENDATIONS = "RECOMMENDATIONS";
export const RECOMMENDATIONS_ERROR = "RECOMMENDATIONS_ERROR";
export const RECOMMENDATIONS_MSG = "RECOMMENDATIONS_MSG";
export const RECOMMENDATIONS_CLEAR_MSG = "RECOMMENDATIONS_CLEAR_MSG";
export const RECOMMENDATIONS_HIDE_ERROR = "RECOMMENDATIONS_HIDE_ERROR";
export const RECOMMENDATIONS_START_LOADER = "RECOMMENDATIONS_START_LOADER";
export const RECOMMENDATIONS_STOP_LOADER = "RECOMMENDATIONS_STOP_LOADER";
